import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from './utils/auth/authHeader';
import Image from 'helpers/Image';
import { AttendanceIcon, RfidIcon, ReportIcon } from 'components/icons';
import 'views/auth/style.css';

const features = [
    {
        tone: "mint",
        icon: <AttendanceIcon />,
        title: "Real-time attendance and roll call",
        note: "Know who's on-site, always.",
    },
    {
        tone: "violet",
        icon: <RfidIcon />,
        title: "RFID gateway and zone-level tracking",
        note: "Secure sites. Smarter movement.",
    },
    {
        tone: "amber",
        icon: <ReportIcon />,
        title: "First-in / last-out and absentee reports",
        note: "Insights for better decisions.",
    },
];

function AuthLayout() {
    return (
        <div className="service-view-auth">
            <AuthHeader />

            <div className="login-bg">

                <section className="auth-visual">
                    <div className="auth-visual-body">
                        <header className="auth-topbar">
                            <Image name="woh_hup_logo.png" className="auth-topbar-logo" />
                        </header>

                        <div className="auth-pitch">
                            <span className="auth-eyebrow">Employee Tracking System</span>
                            <h1>
                                Every shift, every zone,
                                <span className="auth-accent"> accounted for.</span>
                            </h1>
                            <p className="auth-sub">
                                Monitor attendance, movement and site access across
                                your workforce from a single dashboard.
                            </p>

                            <ul className="auth-features">
                                {features.map((item) => (
                                    <li key={item.title}>
                                        <span className={`auth-feature-icon is-${item.tone}`}>{item.icon}</span>
                                        <span className="auth-feature-text">
                                            <strong>{item.title}</strong>
                                            <em>{item.note}</em>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="auth-formside">
                    <span className="auth-formside-motto">Safer Workplaces<br />Brighter Tomorrow</span>

                    <div className="login-card">
                        <div className="login-card-head">
                            <Image name="woh_hup_logo.png" />
                            <p className="login-card-product">Employee Tracking System</p>
                        </div>

                        <Outlet />
                    </div>

                    <p className="auth-formside-legal">
                        <span>Secure &middot; Compliant &middot; People First</span>
                        &copy; {new Date().getFullYear()} Woh Hup Engineering. All rights reserved.
                    </p>
                </section>

            </div>
        </div>
    );
}

export default AuthLayout;
